(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-offer-countdown"] && !Shopify.designMode) return;
  try {
    
class AuraOfferCountdown extends HTMLElement {
  connectedCallback() {
    const value=this.dataset.endsAt||'';
    if(!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(value))return;
    this.end=Date.parse(value);
    if(!Number.isFinite(this.end)||this.end<=Date.now())return;
    this.querySelector('[data-end-label]').textContent=new Intl.DateTimeFormat('es-CL',{dateStyle:'medium',timeStyle:'short',timeZone:'America/Santiago'}).format(new Date(this.end));
    this.querySelector('time').dateTime=value;
    this.tick();
    this.timer=setInterval(()=>this.tick(),1000);
  }
  tick() {
    const remaining=Math.max(0,Math.ceil((this.end-Date.now())/1000));
    if(!remaining){this.hidden=true;clearInterval(this.timer);return;}
    const values=[Math.floor(remaining/86400),Math.floor(remaining%86400/3600),Math.floor(remaining%3600/60),remaining%60];
    values.forEach((n,i)=>{this.querySelector('[data-part="'+i+'"]').textContent=String(n).padStart(2,'0');});
    this.hidden=false;
  }
  disconnectedCallback(){clearInterval(this.timer);}
}
if(!customElements.get('aura-offer-countdown'))customElements.define('aura-offer-countdown',AuraOfferCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
